import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';

const Portfolio = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Load the SociableKit widget script
    const script = document.createElement('script');
    script.src = 'https://widgets.sociablekit.com/instagram-feed/widget.js';
    script.defer = true;
    document.body.appendChild(script);

    // Style the widget after it loads
    const styleInterval = setInterval(() => {
      const widget = document.querySelector('.sk-instagram-feed');
      if (widget) {
        // Found the widget, apply custom styles
        clearInterval(styleInterval);
        
        // Add custom CSS for the widget
        const style = document.createElement('style');
        style.textContent = `
          /* Custom Instagram Feed Styling */
          .sk-instagram-feed {
            background: transparent !important;
            border: none !important;
            padding: 0 !important;
          }
          
          .sk-instagram-feed * {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
          }
          
          /* HIDE SOCIABLEKIT BRANDING AND EMBED BUTTONS */
          .sk-instagram-feed a[href*="sociablekit"],
          .sk-instagram-feed button[class*="embed"],
          .sk-instagram-feed div[class*="embed"],
          .sk-instagram-feed .sk-ww-instagram-feed-embed-button,
          .sk-instagram-feed [class*="powered"],
          .sk-instagram-feed [class*="branding"] {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
          }
          
          /* HIDE VERIFICATION BADGES / COLORED BARS / PINK SQUARES */
          .sk-instagram-feed .sk-ww-instagram-feed-header-verified,
          .sk-instagram-feed [class*="badge"],
          .sk-instagram-feed [class*="verified"],
          .sk-instagram-feed header svg:not(.sk-ww-instagram-feed-header-avatar svg),
          .sk-instagram-feed header span[style*="background"],
          .sk-instagram-feed header div[style*="background"]:not(.sk-ww-instagram-feed-header-avatar),
          .sk-instagram-feed header > div > div:not([class*="avatar"]):not([class*="username"]):not([class*="stats"]):not([class*="bio"]),
          .sk-instagram-feed header > div > span,
          .sk-instagram-feed header > span,
          .sk-instagram-feed .sk-ww-instagram-feed-header > div > div:first-child > div:not([class*="avatar"]),
          .sk-instagram-feed .sk-ww-instagram-feed-header-left > div:not([class*="avatar"]):not([class*="info"]) {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
            width: 0 !important;
            height: 0 !important;
          }
          
          /* Hide any colored decorative elements */
          .sk-instagram-feed header div[style*="rgb"],
          .sk-instagram-feed header div[style*="rgba"],
          .sk-instagram-feed header div[style*="#"] {
            display: none !important;
            visibility: hidden !important;
          }
          
          /* Header styling */
          .sk-instagram-feed header {
            background: rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: blur(10px) !important;
            border: 1px solid rgba(255, 255, 255, 0.15) !important;
            border-radius: 16px !important;
            padding: 24px !important;
            margin-bottom: 24px !important;
          }
          
          /* Make ALL text readable with white/light colors */
          .sk-instagram-feed header *,
          .sk-instagram-feed .sk-ww-instagram-feed-header *,
          .sk-instagram-feed [class*="username"],
          .sk-instagram-feed [class*="name"],
          .sk-instagram-feed [class*="bio"],
          .sk-instagram-feed h1,
          .sk-instagram-feed h2,
          .sk-instagram-feed h3,
          .sk-instagram-feed p,
          .sk-instagram-feed span {
            color: rgba(255, 255, 255, 0.95) !important;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;
          }
          
          /* Username specifically */
          .sk-instagram-feed .sk-ww-instagram-feed-header-username,
          .sk-instagram-feed a[href*="instagram.com"] {
            color: #fbbf24 !important;
            font-weight: 600 !important;
            text-decoration: none !important;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5) !important;
          }
          
          /* Stats (posts, followers, following) */
          .sk-instagram-feed .sk-ww-instagram-feed-header-stats * {
            color: rgba(255, 255, 255, 0.9) !important;
            font-weight: 600 !important;
          }
          
          /* Bio text */
          .sk-instagram-feed .sk-ww-instagram-feed-header-bio {
            color: rgba(255, 255, 255, 0.85) !important;
            line-height: 1.6 !important;
          }
          
          /* Profile image glow effect */
          .sk-instagram-feed img[alt*="profile" i] {
            border: 3px solid rgba(168, 85, 247, 0.6) !important;
            box-shadow: 0 0 25px rgba(168, 85, 247, 0.5) !important;
          }
          
          /* Post grid styling */
          .sk-instagram-feed .sk-ww-instagram-feed-posts {
            display: grid !important;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)) !important;
            gap: 20px !important;
            padding: 0 !important;
          }
          
          /* Individual post cards */
          .sk-instagram-feed .sk-ww-instagram-feed-post {
            background: rgba(255, 255, 255, 0.05) !important;
            backdrop-filter: blur(10px) !important;
            border: 1px solid rgba(255, 255, 255, 0.1) !important;
            border-radius: 16px !important;
            overflow: hidden !important;
            transition: all 0.3s ease !important;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
          }
          
          .sk-instagram-feed .sk-ww-instagram-feed-post:hover {
            transform: translateY(-8px) !important;
            border-color: rgba(168, 85, 247, 0.5) !important;
            box-shadow: 0 8px 30px rgba(168, 85, 247, 0.3) !important;
          }
          
          /* Post images */
          .sk-instagram-feed .sk-ww-instagram-feed-post img {
            width: 100% !important;
            height: 280px !important;
            object-fit: cover !important;
            transition: transform 0.3s ease !important;
          }
          
          .sk-instagram-feed .sk-ww-instagram-feed-post:hover img {
            transform: scale(1.05) !important;
          }
          
          /* Caption styling */
          .sk-instagram-feed .sk-ww-instagram-feed-post-caption {
            color: rgba(255, 255, 255, 0.9) !important;
            padding: 16px !important;
            font-size: 14px !important;
            line-height: 1.6 !important;
            background: rgba(0, 0, 0, 0.2) !important;
          }
          
          /* Like and comment counts */
          .sk-instagram-feed .sk-ww-instagram-feed-post-likes,
          .sk-instagram-feed .sk-ww-instagram-feed-post-comments {
            color: rgba(255, 255, 255, 0.8) !important;
            font-size: 13px !important;
            font-weight: 600 !important;
          }
          
          /* Follow button */
          .sk-instagram-feed button,
          .sk-instagram-feed a[href*="instagram.com/mysticgoddessbeautystudio"] {
            background: linear-gradient(135deg, #a855f7, #ec4899) !important;
            color: white !important;
            border: none !important;
            padding: 12px 24px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            transition: all 0.3s ease !important;
            text-decoration: none !important;
          }
          
          .sk-instagram-feed button:hover,
          .sk-instagram-feed a[href*="instagram.com/mysticgoddessbeautystudio"]:hover {
            transform: scale(1.05) !important;
            box-shadow: 0 4px 20px rgba(168, 85, 247, 0.4) !important;
          }
          
          /* Load more button */
          .sk-instagram-feed .sk-ww-instagram-feed-load-more {
            background: rgba(168, 85, 247, 0.2) !important;
            border: 2px solid rgba(168, 85, 247, 0.5) !important;
            color: white !important;
            padding: 14px 32px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            margin: 32px auto !important;
            display: block !important;
            transition: all 0.3s ease !important;
          }
          
          .sk-instagram-feed .sk-ww-instagram-feed-load-more:hover {
            background: rgba(168, 85, 247, 0.4) !important;
            border-color: rgba(168, 85, 247, 0.8) !important;
            transform: scale(1.05) !important;
          }
          
          /* Scrollbar styling */
          .sk-instagram-feed ::-webkit-scrollbar {
            width: 8px !important;
          }
          
          .sk-instagram-feed ::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05) !important;
            border-radius: 4px !important;
          }
          
          .sk-instagram-feed ::-webkit-scrollbar-thumb {
            background: rgba(168, 85, 247, 0.5) !important;
            border-radius: 4px !important;
          }
          
          .sk-instagram-feed ::-webkit-scrollbar-thumb:hover {
            background: rgba(168, 85, 247, 0.7) !important;
          }
          
          /* Responsive adjustments */
          @media (max-width: 768px) {
            .sk-instagram-feed .sk-ww-instagram-feed-posts {
              grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)) !important;
              gap: 16px !important;
            }
            
            .sk-instagram-feed .sk-ww-instagram-feed-post img {
              height: 250px !important;
            }
          }
          
          @media (max-width: 480px) {
            .sk-instagram-feed .sk-ww-instagram-feed-posts {
              grid-template-columns: 1fr !important;
              gap: 12px !important;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }, 100);

    // Clear interval after 10 seconds to prevent memory leak
    setTimeout(() => clearInterval(styleInterval), 10000);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-purple-800 relative overflow-hidden">
      {/* Animated stars background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(100)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full animate-twinkle"
            style={{
              width: Math.random() * 3 + 1 + 'px',
              height: Math.random() * 3 + 1 + 'px',
              left: Math.random() * 100 + '%',
              top: Math.random() * 100 + '%',
              animationDelay: Math.random() * 5 + 's',
              animationDuration: (Math.random() * 3 + 2) + 's',
            }}
          />
        ))}
      </div>

      {/* Mystical glow effects */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      
      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <header className="border-b border-white/10 bg-black/20 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex items-center justify-between">
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 text-purple-200 hover:text-white transition-colors group"
              >
                <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
                <span className="text-sm font-medium">Back to Home</span>
              </button>
              
              <div className="flex items-center gap-2">
                <Sparkles className="w-5 h-5 text-purple-300 animate-pulse" />
                <h1 className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-pink-200 to-purple-300">
                  Our Portfolio
                </h1>
                <Sparkles className="w-5 h-5 text-purple-300 animate-pulse" style={{ animationDelay: '0.5s' }} />
              </div>
              
              <div className="w-20" /> {/* Spacer for centering */}
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Instagram Feed Container */}
          <div className="mb-16">
            <div className="text-center mb-8">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight">
                ✨ Mystical Transformations ✨
              </h2>
              <p className="text-purple-200 text-lg max-w-2xl mx-auto">
                Witness the magic of our artistry through these divine creations
              </p>
            </div>

            {/* Instagram Embed with mystical border */}
            <div className="relative">
              {/* Decorative corners */}
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-purple-400/50 rounded-tl-3xl pointer-events-none" />
              <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-purple-400/50 rounded-tr-3xl pointer-events-none" />
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-purple-400/50 rounded-bl-3xl pointer-events-none" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-purple-400/50 rounded-br-3xl pointer-events-none" />
              
              {/* Main feed container */}
              <div className="bg-black/30 backdrop-blur-xl rounded-2xl p-4 sm:p-6 md:p-10 border border-purple-400/30 shadow-2xl shadow-purple-500/20">
                <div 
                  className="sk-instagram-feed" 
                  data-embed-id="25671381"
                  style={{
                    minHeight: '800px',
                  }}
                />
              </div>
            </div>
          </div>

          {/* Call to Action Section */}
          <div className="relative">
            {/* Mystical glow behind CTA */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600/20 to-pink-600/20 blur-3xl rounded-full" />
            
            <div className="relative bg-gradient-to-br from-purple-900/40 to-pink-900/40 backdrop-blur-xl rounded-3xl p-8 md:p-12 border border-purple-400/30 shadow-2xl">
              <div className="text-center">
                <div className="inline-flex items-center gap-2 mb-6">
                  <div className="w-16 h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent" />
                  <Sparkles className="w-6 h-6 text-purple-300" />
                  <div className="w-16 h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent" />
                </div>
                
                <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
                  Ready for Your
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300">
                    Divine Transformation?
                  </span>
                </h3>
                
                <p className="text-purple-200 text-lg mb-8 max-w-2xl mx-auto">
                  Step into our sanctuary and let us unveil your inner goddess
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <button
                    onClick={() => navigate('/')}
                    className="group relative px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-purple-500/50"
                  >
                    <span className="relative z-10 flex items-center gap-2">
                      ✨ Book Your Transformation
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </button>
                  
                  <button
                    onClick={() => navigate('/gift-cards')}
                    className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-xl border-2 border-purple-400/50 hover:border-purple-400 transition-all duration-300 backdrop-blur-sm"
                  >
                    🎁 Gift the Magic
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="mt-20 py-8 border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-center text-purple-300/60 text-sm">
              ✨ Mystic Goddess Beauty Studio • Where Magic Meets Beauty ✨
            </p>
          </div>
        </footer>
      </div>

      <style jsx>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 1; }
        }
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Portfolio;
